module.exports = __webpack_public_path__ + "img/2.78d6f106.gif";